/** product group types */
export enum ProductGroupType {
  single = 'single',
  double = 'double',
  triple = 'triple',
  slider = 'slider'
}


/** product types */
export enum ProductType {
  amazon = 'amazon',
  manual = 'manual',
  awin = 'awin'
}